import { useLazyQuery } from '@apollo/client/react';
import { useEffect, useState } from 'react';

import {
  GetPrescriptionFromNodeDocument,
  PrescriptionAppointmentFromNodeFragment,
} from '~/graphql/generated/graphql';
import { getNode } from '~/graphql/utility';

export const useFetchAppointment = (
  isOpen: boolean,
  appointmentId: string,
): {
  loading: boolean;
  called: boolean;
  error: Error | null;
  appointment?: PrescriptionAppointmentFromNodeFragment;
} => {
  const [error, setError] = useState<Error | null>(null);

  const [getAppointment, { called, loading, data, error: appointmentError }] = useLazyQuery(
    GetPrescriptionFromNodeDocument,
    {
      fetchPolicy: 'network-only',
      nextFetchPolicy: 'cache-first',
    },
  );

  const appointment = getNode(data, 'Appointment');

  useEffect(() => {
    if (appointmentError) {
      setError(appointmentError);
    }
  }, [appointmentError]);

  useEffect(() => {
    if (isOpen && appointmentId) {
      getAppointment({ variables: { appointmentId } });
    }
  }, [appointmentId, isOpen, getAppointment]);

  return { loading: !called || loading, called, error, appointment };
};
